// FOUNDATION

$(document).foundation();


// FUNCTIONS

function onScroll() {
    var scrollPos = $(document).scrollTop();
    $('.sub-bar li a').each(function () {
        if (!$(this).hasClass('button-anfrage')) {
            var currLink = $(this);
            var refElement = $(currLink.attr("href"));
            if ((refElement.position()?.top - $('#navigation-container').height()) <= scrollPos && (refElement.position().top - $('#navigation-container').height()) + refElement.height() > scrollPos) {
                $('.sub-bar li a').removeClass("active");
                currLink.addClass("active");
            } else {
                currLink.removeClass("active");
            }
        }
    });
}


// DOCUMENT READY

$(document).ready(function () {

    // MOBILE NAV

    var body = $('body');

    var hamburger = $(".hamburger");
    var mobileNav = $(".mobile-nav");

    $(".hamburger").click(function() {
        hamburger.toggleClass("change");
        if (mobileNav.hasClass("opened")) {
            mobileNav.removeClass("opened");
        } else {
            mobileNav.addClass("opened");
        }
    });

    if ( (!body.is("#impressum")) && (!body.is("#datenschutz")) ) {
        $(document).on("scroll", onScroll);
    }

    // SMOOTH SCROLL

    $('a[href^="#"]').on('click', function (e) {
        e.preventDefault();
        if ($(window).innerWidth() < 1024) {
            $(this).parents('.top-bar').css('display', 'none');
        }
        $(document).off("scroll");
        $('.sub-bar li a').each(function () {
            $(this).removeClass('active');
        });
        $(this).addClass('active');
        var target = this.hash;
        target = $(target);
        if ($(window).innerWidth() < 1024) {
            $('html, body').stop().delay(500).animate({
                'scrollTop': target.offset().top - $('#navigation-container').height() + 2
            }, 1000, 'swing', function () {
                $(document).on("scroll", onScroll);
            });
        } else {
            $('html, body').stop().animate({
                'scrollTop': target.offset().top - $('#navigation-container').height() + 2
            }, 1000, 'swing', function () {
                $(document).on("scroll", onScroll);
            });
        }

    });
});


// AJAX FORM SUBMIT

$(function () {

    var body = $('body');

    // Get the form.
    var form = $('#form-anfrage');

    // Get the messages div.
    var formMessages = $('#form-messages');

    // Set up an event listener for the contact form.
    $(form).submit(function (e) {
        // Stop the browser from submitting the form.
        e.preventDefault();

        // Serialize the form data.
        var formData = $(form).serialize();

        // Submit the form using AJAX.
        $.ajax({
            type: 'POST',
            url: $(form).attr('action'),
            data: formData
        })
        .done(function (response) {
            // Make sure that the formMessages div has the 'success' class.
            $(formMessages).removeClass('error');
            $(formMessages).addClass('success');

            // Set the message text.
            $(formMessages).text(response);

            // Clear the form.
            $('#beratung').val('');
            $('#beratung').prop('checked', false);
            $('#infomaterial').val('');
            $('#infomaterial').prop('checked', false);
            $('#angebot').val('');
            $('#angebot').prop('checked', false);
            $('#interesse').val('– Bitte auswählen –');
            $('#vorname').val('');
            $('#nachname').val('');
            $('#email').val('');
            $('#emailconfirm').val('');
            $('#telefon').val('');
            $('#strasse').val('');
            $('#plz').val('');
            $('#ort').val('');
            $('#land').val('– Bitte auswählen –');
            $('#nachricht').val('');

            // Push event (Google)
            if (body.is("#module")) {
                dataLayer.push({'event': 'Anfrage_Module'});
            } else {
                dataLayer.push({'event': 'Anfrage'});
            }

        })
        .fail(function (data) {
            // Make sure that the formMessages div has the 'error' class.
            $(formMessages).removeClass('success');
            $(formMessages).addClass('error');

            // Set the message text.
            if (data.responseText !== '') {
                $(formMessages).text(data.responseText);
            } else {
                $(formMessages).text('Leider ist ein Fehler aufgetreten und Ihre Anfrage konnte nicht an uns gesendet werden.');
            }
        });
    });
});